module.exports = __webpack_public_path__ + "img/fondo-login.be625f9e.png";